<template>
  <div
    ref="container"
    class="read-more"
    :class="{'_opened': isOpened}"
  >
    <slot></slot>
  </div>
  <div v-if="isReadMore"
    class="read-more__button"
    @click="isOpened = !isOpened"
  >
    {{ isOpened? 'Скрыть': 'Показать полностью' }}
  </div>
</template>
<script setup>
import { ref, onMounted } from 'vue';

const container =  ref(null);

const isOpened = ref(false);
const isReadMore = ref(false)

const initReadMore = () => {
  if (!container || !container.value) {
    return;
  }
  if (container.value.scrollHeight > container.value.clientHeight) {
    isReadMore.value = true;
  }
}

onMounted(() => {
  initReadMore();
  window.addEventListener("resize", initReadMore);
})

</script>
